import { Directive, Input, OnInit, ViewContainerRef, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import * as fromRoot from '../../store';
import { Store, select } from '@ngrx/store';
import { Role } from '../models/role';
/**
 * Permite mostrar bloques a roles en espeficico
 */
@Directive({
  selector: '[appVisibleToRole]'
})
export class VisibleToRoleDirective implements OnInit, OnChanges {

  @Input() role: string[];

  currentRole: Role;
  isVisible = false;

  constructor(
    private store: Store<fromRoot.AuthState>,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {}

  ngOnInit() {
    this.checkInputRequired(this.role);
    this.handleVisibility();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkInputRequired(this.role);
  }

  checkInputRequired(input: string[]) {
    if (!input) {
      throw new Error('Attribute role is required');
    }
  }

  handleVisibility() {
    this.store.pipe(
      select(fromRoot.selectSessionCurrentrole)
    ).subscribe(currentRole => {
      this.currentRole = currentRole;
      if (!currentRole.code) {
        return this.viewContainerRef.clear();
      }
      if (this.role.includes(this.currentRole.code) && !this.isVisible) {
        this.isVisible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.isVisible = false;
        this.viewContainerRef.clear();
      }
    });
  }
}
